export default function logClientError(errorData) {
  const userId = window.currentUserId || null; // Injected from Laravel Blade

  axios
    .post('/log-client-error', {
      ...errorData,
      userId,
      userAgent: navigator.userAgent,
      url: window.location.href,
      timestamp: new Date().toISOString(),
    })
    .catch((error) => {
      console.error('Error logging client error:', error);
    });
}
